<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
  layout: WebLayout,
}
</script>

<script setup>
import { onMounted, nextTick, computed } from 'vue'
import SEOHead from '@/components/SEOHead.vue'
import { useScrollReveal } from '@/composables/useScrollReveal.js'
import { useWebTranslations } from '@/composables/useWebTranslations.js'

import HeroSection from './components/HeroSection.vue'
import TrustBar from './components/TrustBar.vue'
import Ecosystem from './components/Ecosystem.vue'
import Unlimited from './components/Unlimited.vue'
import TemplatesSection from './components/TemplatesSection.vue'
import Integrations from './components/Integrations.vue'
import EarlyAdopters from './components/EarlyAdopters.vue'
import PricingSection from './components/PricingSection.vue'
import Infrastructure from './components/Infrastructure.vue'
import ContactSection from './components/ContactSection.vue'

const { refresh } = useScrollReveal()

onMounted(() => {
  nextTick(() => {
    refresh()
  })
})

const { get, locale, webRoute, alternateLocales } = useWebTranslations()
const seoTitle = computed(() => get('seo.home_title'))
const seoDescription = computed(() => get('seo.home_description'))
const seoKeywords = computed(() => get('seo.home_keywords'))
const canonicalPath = computed(() => webRoute('web.home'))
const pageAlternateLocales = computed(() => alternateLocales('web.home'))

const organizationSchema = computed(() => ({
  '@type': 'Organization',
  name: 'Growiyo',
  url: 'https://growiyo.com',
  logo: 'https://growiyo.com/images/logo.webp',
  description: seoDescription.value,
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'SI',
  },
}))

const scrollToCta = () => {
  const ctaSection = document.getElementById('contact')
  if (ctaSection) ctaSection.scrollIntoView({ behavior: 'smooth' })
}
</script>

<template>
  <SEOHead
    :title="seoTitle"
    :description="seoDescription"
    :keywords="seoKeywords"
    :canonical="canonicalPath"
    :locale="locale"
    :alternate-locales="pageAlternateLocales"
    :structured-data="organizationSchema"
    type="website"
  />

  <!-- 01 · Hero — Obljuba + primarni CTA -->
  <HeroSection :scroll-to-cta="scrollToCta" />
  <!-- Previous hero kept as HeroSectionOld.vue (swap import to restore) -->

  <!-- 02 · Trust bar — Številčno zaupanje nad prvim zaslonom -->
  <TrustBar />

  <!-- 03 · Ecosystem — Ena platforma -->
  <Ecosystem />

  <!-- 04 · Unlimited — Brez meja, platforma raste z vami -->
  <Unlimited />

  <!-- 05 · Templates — Predloge za vašo trgovino -->
  <TemplatesSection />

  <!-- 06 · Integrations — Odpravi dvome "ali deluje z mojim stackom" -->
  <Integrations />

  <!-- 07 · Early adopters — Za vsako dejavnost -->
  <EarlyAdopters />

  <!-- 08 · Pricing — Preglednica ponudbe -->
  <PricingSection />

  <!-- 09 · Infrastructure — Zadnji pomiritveni signal -->
  <Infrastructure />

  <!-- 10 · Contact — Zavezanost -->
  <ContactSection />
</template>
